module.exports = __webpack_public_path__ + "static/media/logo_pic-collage.060d67d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_pic-collage.png
// module id = 135
// module chunks = 0